<template>
  <div class="d-flex">
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="40" height="40" fill="#F5F5F4" />
      <path
        d="M16.4199 20.1695C17.1917 21.7633 18.4804 23.0487 20.0762 23.8164C20.1939 23.8721 20.3241 23.8962 20.4539 23.8864C20.5838 23.8765 20.7089 23.833 20.8168 23.7601L23.1605 22.1945C23.2641 22.1243 23.3838 22.0814 23.5083 22.07C23.6329 22.0585 23.7584 22.0788 23.873 22.1289L28.2605 24.0133C28.4105 24.0757 28.5358 24.1856 28.6171 24.3263C28.6984 24.4669 28.7312 24.6303 28.7105 24.7914C28.5715 25.8768 28.0417 26.8743 27.2203 27.5973C26.399 28.3203 25.3423 28.7193 24.248 28.7195C20.8665 28.7195 17.6235 27.3762 15.2324 24.9851C12.8413 22.594 11.498 19.351 11.498 15.9695C11.4983 14.8753 11.8972 13.8186 12.6203 12.9972C13.3433 12.1759 14.3408 11.6461 15.4262 11.507C15.5873 11.4863 15.7507 11.5192 15.8913 11.6005C16.0319 11.6818 16.1419 11.8071 16.2043 11.957L18.0887 16.3539C18.1377 16.4667 18.1582 16.5899 18.1484 16.7125C18.1386 16.8351 18.0987 16.9534 18.0324 17.057L16.4668 19.4383C16.3971 19.546 16.3562 19.6697 16.348 19.7978C16.3398 19.9258 16.3645 20.0538 16.4199 20.1695V20.1695Z"
        stroke="#1F1F1F"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M23.498 12.9697H27.248V16.7197"
        stroke="#1F1F1F"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M22.748 17.4697L27.248 12.9697"
        stroke="#1F1F1F"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </div>
</template>
